import React, { PureComponent } from 'react'
import { View } from 'react-native'
import theme from '../../../../styles/theme'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  background: ${theme.colours.white}
`

const ColumnWrapper = styled(View)`
  flex-direction: row;
  justify-content: center;
  padding: ${theme.gutterUnit}px;
`

const Column = styled(View)`
  flex-direction: column;
  width: ${props => 100 / props.count}%;
  justify-content: flex-end;
  max-width: ${props => `${props.count <= 4 ? '25%' : '100%'}`};
`

const BoxWrapper = styled(View)`
  padding: 2px ${theme.gutterUnit}px;
`

const RoundedBox = styled(View)`
  background: ${props => props.background};
  padding:  ${({ collapse }) => collapse ? '2px' : `${theme.gutterUnit}px`};
  width: 100%;
  align-items: center;
  border-radius: ${theme.gutterUnit / 2}px;
  flex-direction: ${props => props.collapse ? 'row' : 'column'};
  justify-content: center;
`

const ratingSort = ['AAA', 'AA', 'A', 'BBB', 'BB', 'B']

const ratingColours = {
  AAA: '#12a86c',
  AA: '#36bdac',
  A: '#19d1a4',
  BBB: '#e46c60',
  BB: '#e46c60',
  B: '#bf1c33'
}

const stackThreshold = 5

export default class CapitalRatio extends PureComponent {
  render () {
    const columns = this.props.data.reduce((acc, { rating }) => {
      if (!acc.includes(rating)) acc.push(rating)
      return acc
    }, []).sort((a, b) => ratingSort.indexOf(a) - ratingSort.indexOf(b)).map(rating => {
      const thisRating = {
        rating,
        teams: this.props.data.filter(team => team.rating === rating).map(({ value, name, team }) => ({
          team,
          name,
          value,
          collapse: false
        }))
      }
      if (thisRating.teams.length > stackThreshold) {
        for (const team in thisRating.teams) {
          thisRating.teams[team].collapse = true
        }
      }
      return thisRating
    })
    return (
      <Container>
        <ColumnWrapper>
          {columns.map((column, i) => (
            <Column count={columns.length} key={i}>
              {column.teams.map((team, i) => (
                <BoxWrapper key={i}>
                  <RoundedBox background={team.team === this.props.currentTeam ? theme.colours.chart.orange : ratingColours[column.rating]} collapse={team.collapse}>
                    <Text white size={team.collapse ? 'm' : 's'} overrides={{ paddingBottom: team.collapse ? 0 : 1, paddingRight: team.collapse ? 5 : 0 }}>{team.name}</Text>
                    <Text white size={team.collapse ? 'm' : 'l'} bold={team.collapse}>{parseFloat(team.value / 100).toFixed(2) + '%'}</Text>
                  </RoundedBox>
                </BoxWrapper>
              ))}
            </Column>
          ))}
        </ColumnWrapper>
        <ColumnWrapper style={{ borderTopColor: theme.colours.bordergrey, borderTopWidth: 1 }}>
          {columns.map((column, i) => (
            <Column count={columns.length} key={i}>
              <BoxWrapper>
                <RoundedBox background={ratingColours[column.rating]}>
                  <Text white size='l'>{column.rating}</Text>
                </RoundedBox>
              </BoxWrapper>
            </Column>
          ))}
        </ColumnWrapper>
      </Container>
    )
  }
}
